<template>
  <div>
    <Loader />
    <router-view />
  </div>
</template>

<script>
import Loader from './components/shared/Loader.vue'
export default {
  components: { Loader },
  name: 'AuthApp',
}
</script>
